<template>
  <AdminAddSystemPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminAddSystemPage from "shared-ui/pages/AdminAddSystemPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_add_system.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
